import React from "react"
import Carousel from 'react-bootstrap/Carousel'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '../components/Material-UI-Components/Button.js';

import SEO from "../components/seo"
import Layout from '../components/layout'
import ContactForm from '../components/Custom Modules/ContactForm';

/* importing json data */
import CarouselData from '../components/Page-Data/Carousel-Data.json';

/* importing image */
import ADOLESCENT from '../images/MainPage/ADOLESCENT.png';
import CAREER from '../images/MainPage/CAREER.png';
import COUNSELLING from '../images/MainPage/COUNSELLING.png';
import RELATIONSHIP from '../images/MainPage/RELATIONSHIP.png';
import TRAINING from '../images/MainPage/TRAINING.png';
import HomePageBackGround from '../images/MainPage/HomePageBackGround.png';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    boxShadow: 'none',
    fontSize: '16px',
    color: '#424242',
    margin: 'auto',
    maxWidth: 600,
  },
  imageDiv: {
    maxWidth: '100%',
    minWidth: '100%',
    display: 'block'
  },
  image: {
    width: '100%',
    height: '100%',
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: 10
  },
  heading:{
    fontSize:'16px',
    color:'#f7941e',
    marginBottom: '30px'  
  },
  bodyDesciption:{
    marginTop: 30
  },
  button:{
    textAlign: 'center',
    marginTop: 25
  },
  buttonProps:{
    color:"#003a4d", 
    borderColor: "#003a4d",
    backgroundColor:'#fffff'
  },
  marginBottom40:{
    marginBottom:0
  },
  carouselContainer:{
    paddingLeft:0,
    paddingRight:0
  },
  headingFontColor:{
    color: '#FFFFFF'
  }
}));

function IndexPage(props) {
  const classes = useStyles();

  const [index, setIndex] = React.useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  React.useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % CarouselData.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return(
    <Layout mainPage={true}>
      <SEO 
        title="Career Counselling Jaipur, Family Counselling Services in India, Pratiiti.com"
        description="Career and Family Counselling-Get best counsellors for Career counselling, family counselling, Adolescent counselling in Jaipur, India at affordable rates."
        canonical={"https://www.pratiiti.in"} 
      />

    <div className={classes.carouselContainer}>
    <Carousel activeIndex={index} onSelect={handleSelect}>

        {CarouselData.map((index)=>{
          return(
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={require(`../images/slider/${index["imageLink"]}`)} 
                alt={index["alt"]}
              />
              <Carousel.Caption>
                <h3 style={{fontSize: 20, color:'#000000'}}>{index["captionLabel"]}</h3>
                <p style={{color:'#000000'}}>{index["captionLabelDescription"]}</p>
              </Carousel.Caption>
            </Carousel.Item>
          )
        })}
        
    </Carousel>
    </div>

    <div className={classes.root}>
    <Grid container className={"mainPageBackGround"}>   

   <Grid item xs={12} sm={6} className={classes.paper}>
        <img className={classes.img} style={{marginTop:'30px'}} src={CAREER} alt="#" />
    </Grid>
    
    <Grid item xs={12} sm={6} className={classes.paper}>
        <div className={classes.bodyDesciption}>
          <div className={classes.heading}>
            <h2 className={classes.headingFontColor}>Career Counselling</h2>
          </div>
        
          <div>
            <h3 style={{fontSize: 20}}>It is not enough to survive, we need to thrive! 
              So find out what you are good at, what are your key strengths and 
              interests and what would be the best suitable career for you!</h3>
          </div>
        </div>  
    </Grid>

    <Grid item xs={12} className={classes.button}>
      <Button 
        label={"Find out more..."}
        onClick={()=>props.navigate('career-counselling')}
      >
        Find out more...
      </Button>
    </Grid>

    <Grid item xs={12} sm={6} className={classes.paper}>
        <div className={classes.bodyDesciption}>
          <div className={classes.heading}>
            <h2 className={classes.headingFontColor}>Adolescents Specific Services</h2>
          </div>
        
          <div>
            <h3 style={{fontSize: 20}}>Difficult roads lead to beautiful destinations.  Teenage years are the most difficult and confusing. You are treated like a kid and expected to act like adult. Best friendships and worst heartbreaks happen. So discover the unfolding of beautiful you!</h3>
          </div>
        </div>  
    </Grid>

    <Grid item xs={12} sm={6} className={classes.paper}>
        <img className={classes.img} style={{marginTop:'30px'}} src={ADOLESCENT} alt="#" />
    </Grid>

    <Grid item xs={12} className={classes.button}>
      <Button 
        label={"Find out more..."}
        onClick={()=>props.navigate('adolescent-specific-services')}
      >
        Find out more...
      </Button>
    </Grid>

    <Grid item xs={12} sm={6} className={classes.paper}>
        <img className={classes.img} style={{marginTop:'30px'}} src={COUNSELLING} alt="#" />
    </Grid>

    <Grid item xs={12} sm={6} className={classes.paper}>
        <div className={classes.bodyDesciption}>
          <div className={classes.heading}>
            <h2 className={classes.headingFontColor}>Counselling & Psychotherapy</h2>
          </div>
        
          <div>
            <h3 style={{fontSize: 20}}>It takes courage to face questions you have avoided so far.  We help you confront your fears and turn those mental blocks into building blocks.</h3>
          </div>
        </div>  
    </Grid>

    

    <Grid item xs={12} className={classes.button}>
      <Button 
        label={"Find out more..."}
        onClick={()=>props.navigate('counselling-and-psychotherapy')}
      >
        Find out more...
      </Button>
      
    </Grid>
        

    <Grid item xs={12} sm={6} className={classes.paper}>
        <div className={classes.bodyDesciption}>
          <div className={classes.heading}>
            <h2 className={classes.headingFontColor}>Relationship & Family Counselling</h2>
          </div>
        
          <div>
            <h3 style={{fontSize: 20}}>Mature and trusting relationships don’t happen overnight they are cultivated with commitment, compromise, forgiveness and effort. We help you rekindle romance and have lasting relationship.</h3>
          </div>
        </div>  
    </Grid>

    <Grid item xs={12} sm={6} className={classes.paper}>
          <img className={classes.img} style={{marginTop:'30px'}} src={RELATIONSHIP} alt="#" />
    </Grid>

    <Grid item xs={12} className={classes.button}>
      <Button label={"Find out more..."}
      onClick={()=>props.navigate('relationship-family-counselling')}
      >
        Find out more...
      </Button>
    </Grid>

    <Grid item xs={12} sm={6} className={classes.paper}>
        <img className={classes.img} style={{marginTop:'30px'}} src={TRAINING} alt="#" />
    </Grid>

    <Grid item xs={12} sm={6} className={classes.paper}>
        <div className={classes.bodyDesciption}>
          <div className={classes.heading}>
            <h2 className={classes.headingFontColor}>Training & Workshop</h2>
          </div>
        
          <div>
            <h3 style={{fontSize: 20}}>Training & Workshop is the essence of transformation. We help organizations be more productive and develop skillsets experientially.  We also empower parents, teachers, students and couples through customized target group workshops.</h3>
          </div>
        </div>  
    </Grid>
    
    <Grid item xs={12} className={classes.button}>
      <Button label={"Find out more..."}
      onClick={()=>props.navigate('training-workshop')}
      >
        Find out more...
      </Button>
    </Grid>

    </Grid>
    </div>

    <div className={classes.marginBottom40}></div>
    <ContactForm/>
    </Layout>
  )
}

export default IndexPage
